(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-counter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.community-counter--pop');
    if (!sections.length) return;
    if (!('IntersectionObserver' in window)) {
      sections.forEach((s) => s.classList.add('community-counter--visible'));
      return;
    }
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('community-counter--visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    sections.forEach((s) => io.observe(s));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["impact-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var initImpact = function (root) {
      if (!root || root.dataset.bmf3Init === '1') return;
      root.dataset.bmf3Init = '1';

      var items = root.querySelectorAll('.bmf3-impact__stat');
      if (!items.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
          !('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 120);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });

      items.forEach(function (el) { io.observe(el); });
      root._bmf3Observer = io;
    };

    var initAll = function () {
      document.querySelectorAll('[class*="bmf3-impact--"]').forEach(initImpact);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Theme editor lifecycle
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target) return;
      e.target.querySelectorAll('[class*="bmf3-impact--"]').forEach(initImpact);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      if (!e.target) return;
      e.target.querySelectorAll('[class*="bmf3-impact--"]').forEach(function (root) {
        if (root._bmf3Observer) {
          root._bmf3Observer.disconnect();
          root._bmf3Observer = null;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
